/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.57"
        height="70.9"
        viewBox="0 0 95.57 70.9"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M47.78 0a8.58 8.58 0 1 0 8.58 8.58A8.57 8.57 0 0 0 47.79.01Zm0 2.5a6.08 6.08 0 1 1-6.07 6.09 6.09 6.09 0 0 1 6.07-6.09ZM54.98 20.79a8.18 8.18 0 0 1 8.18 7.94V30a1.25 1.25 0 0 1-1.25 1.25 1.27 1.27 0 0 1-1.25-1.13V29a5.68 5.68 0 0 0-5.48-5.68H40.6a5.7 5.7 0 0 0-5.69 5.48V30a1.25 1.25 0 0 1-1.25 1.25 1.27 1.27 0 0 1-1.25-1.13V29a8.18 8.18 0 0 1 7.94-8.18h14.63Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M47.78 37.23a1.27 1.27 0 0 1 1.25 1.13V50.8a1.25 1.25 0 0 1-2.49.13V38.48a1.25 1.25 0 0 1 1.24-1.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M47.03 49.8a1.26 1.26 0 0 1 1.76.22 1.24 1.24 0 0 1-.15 1.69l-.1.09-9.83 7.42a1.25 1.25 0 0 1-1.61-1.91l.1-.09Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M46.78 50a1.26 1.26 0 0 1 1.64-.32l.12.08 9.82 7.42a1.25 1.25 0 1 1-1.39 2.08l-.11-.08-9.83-7.38a1.27 1.27 0 0 1-.26-1.78Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M80.2 39.63a8.58 8.58 0 1 0 8.57 8.59 8.57 8.57 0 0 0-8.57-8.57Zm0 2.5a6.08 6.08 0 1 1-6.07 6.09 6.07 6.07 0 0 1 6.07-6.09ZM87.38 60.42a8.18 8.18 0 0 1 8.19 7.94v1.28a1.25 1.25 0 0 1-2.49.13v-1.16a5.67 5.67 0 0 0-5.47-5.68H72.98a5.71 5.71 0 0 0-5.69 5.47v1.25a1.24 1.24 0 0 1-1.23 1.25 1.26 1.26 0 0 1-1.25-1.12v-1.16a8.18 8.18 0 0 1 7.94-8.18h14.63ZM15.36 39.63a8.58 8.58 0 1 0 8.58 8.58 8.57 8.57 0 0 0-8.57-8.57Zm0 2.5a6.08 6.08 0 1 1-6.07 6.09 6.09 6.09 0 0 1 6.07-6.09ZM22.55 60.42a8.18 8.18 0 0 1 8.18 7.94v1.28a1.24 1.24 0 0 1-1.23 1.25 1.26 1.26 0 0 1-1.25-1.12v-1.16a5.67 5.67 0 0 0-5.47-5.68H8.18a5.7 5.7 0 0 0-5.69 5.46v1.25a1.25 1.25 0 0 1-2.49.13v-1.16a8.18 8.18 0 0 1 7.94-8.18h14.61Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'ThreePeopleConnectedByInnerLinesIcon';

export default Icon;
